module.exports = __webpack_public_path__ + "img/add-user.6742c27e.png";